var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8574 10.5062C18.0608 10.3318 18.1625 10.2446 18.1998 10.1409C18.2325 10.0498 18.2325 9.9502 18.1998 9.85914C18.1625 9.75539 18.0608 9.6682 17.8574 9.49383L10.7984 3.44331C10.4483 3.14315 10.2732 2.99306 10.1249 2.98939C9.99608 2.98619 9.87302 3.04279 9.7916 3.14269C9.69792 3.25764 9.69792 3.48825 9.69792 3.94948V7.52886C7.91902 7.84007 6.29091 8.74146 5.08101 10.0949C3.76194 11.5704 3.03228 13.48 3.03125 15.4591V15.9691C3.9057 14.9157 4.99751 14.0638 6.23188 13.4716C7.32016 12.9495 8.4966 12.6403 9.69792 12.5588V16.0505C9.69792 16.5117 9.69792 16.7424 9.7916 16.8573C9.87302 16.9572 9.99608 17.0138 10.1249 17.0106C10.2732 17.0069 10.4483 16.8569 10.7984 16.5567L17.8574 10.5062Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame40);
export default __webpack_public_path__ + "static/media/Frame (40).e34f389b8e2dd1c06b9b1c703b491c6d.svg";
export { ForwardRef as ReactComponent };